/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// utils
// material
import { Button, displayModal } from '@insticator/insticator-ui';
import Space from 'material/space/space'
// content
// styles
import injectSheet from "react-jss";
import styles from './testsetupmodal_styles';
import PreviewModeCode from '../pagesetup/productgroup/previewmodecode/previewmodecode';
import { getProductCodeUploadStatus, updateProductManagerConfig } from 'state/thunks/productmanager';
import { Loader } from '@insticator/insticator-ui/dist/material';

/* ========== ~~~~~~~~~~ PRODUCT MANAGER: TEST SETUP MODAL ~~~~~~~~~~ ========== */
const TestSetupModal  = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { siteUUID } = useSelector(state => state.session);
  const { sites } = useSelector(state => state.account) 
  const { tempProductManagerConfig, productManagerConfigChanges } = useSelector(state => state.productManager)
  const [isProcessing, setIsProcessing] = useState(false)
  const [status, setStatus] = useState(null)

  const {  onCancel } = props

  const handleCancel = () => {
    dispatch(displayModal(false))
    onCancel?.()
  }

  const [isTestChangeDisable, setTestChangeDisable] = useState(true)

  const goToSite = () => window.open(`https://${sites[siteUUID]}`, '_blank')

  const refetchStatus = useCallback(async () => {
    console.log('fetching status')
    const response = await dispatch(getProductCodeUploadStatus({ siteId: siteUUID }))
    if(response.error) {
      setIsProcessing(false)
      setStatus('FAILED')
    } else {
      setStatus(response?.payload || 'FAILED')

      if(response.payload === 'SUCCESS' || response.payload === 'FAILED') {
        setIsProcessing(false)
        // onPublish?.()
      }
  
      if(response.payload === 'IN_PROGRESS') {
        setTimeout(() => {
          refetchStatus()
        }, [7000])
      }
    }

  }, [dispatch, siteUUID])

  const handlePublish = useCallback(async () => {
    setIsProcessing(true)
    let response;
    response = await dispatch(updateProductManagerConfig({ productManagerConfig: tempProductManagerConfig, siteId: siteUUID }))
    if(response.payload && !response.payload.errorCode) {
      setTimeout(() => {
        refetchStatus()
      }, [15000])
    } else {
      setIsProcessing(false)
      setStatus('FAILED')
    }

  }, [dispatch, refetchStatus, siteUUID, tempProductManagerConfig])

  useEffect(() => {
    handlePublish()
  }, [])

  if(isProcessing) return (
    <Space direction={'column'} alignItems={'center'} justifyContent={'center'}>
      <Loader />
      <h4>Changes processing...</h4>
      <p style={{ textAlign: 'center', fontSize: '14px'}}>Changes are taking effect, please don’t refresh the page.</p>
    </Space>
  )

  return (
    <div className={'testsetupmodal'}>
     <Space direction={'column'} alignItems={'center'} justifyContent={'center'}>
      <h4>Success</h4>
      <Space direction={'column'} alignItems={'flex-start'} justifyContent={'flex-start'} gap={12} style={{textAlign: 'left',}}>
        <p>Your product group is now ready for testing. </p>
        <div>
          <strong>Directions:</strong>
          <p>1. Please copy the code below.</p>
          <p>2. Click the “Test Changes” button. </p>
          <p>3. Navigate to an article where you expect to see these changes.</p>
          <p>4. Click on the address bar of your browser.</p>
          <p>5. Paste the copied code at the end of the page url.</p>
          <p>6. Refresh the page.</p>
          <p>7. “Preview Mode” is now enabled.</p>
        </div>
        <p className='errormessage'>
          You can now test your changes on this site. These changes are not yet visible to other users.
        </p>
        <p>
          When you’re happy with your changes, click <strong>“Publish Changes”</strong> from the product group. 
          This will publish those changes to the live site and be visible to other users.
        </p>
      </Space>
      <PreviewModeCode handleCopy={() => setTestChangeDisable(false)} />
      <Space style={{marginTop: '32px'}} alignItems={'center'} justifyContent={'center'}>
        <Button text='Close' variant='none' color='light' handleClick={handleCancel} />
        <Button text={'Test Changes'} variant={'primary'} disabled={isTestChangeDisable} handleClick={goToSite} />
      </Space>   
    </Space>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TestSetupModal